import React from "react";

export const CatholicChurch = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={size}
            width={size}
            viewBox="0 0 60 59"
            {...props}>
            <g fillRule="nonzero" fill="none">
                <path
                    d="M32 2h-1V1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v3a1 1 0 002 0V4h1a1 1 0 000-2zM52 19a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1z"
                    fill="#95a5a5"
                />
                <path d="M48 24.27V22a4 4 0 118 0v2.27z" fill="#bdc3c7" />
                <path
                    d="M8 19a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1z"
                    fill="#95a5a5"
                />
                <path d="M4 24.27V22a4 4 0 118 0v2.27z" fill="#bdc3c7" />
                <path
                    d="M57 26v3H47v-3a2 2 0 012-2h6a2 2 0 012 2zM13 26v3H3v-3a2 2 0 012-2h6a2 2 0 012 2z"
                    fill="#e4c05c"
                />
                <path d="M58 29v30H2V29a1 1 0 011-1h54a1 1 0 011 1z" fill="#f9eab0" />
                <path
                    d="M41 24v-4c0-3.82-2.9-7.08-7-8.38V9a2.006 2.006 0 00-2-2h-4a2.006 2.006 0 00-2 2v2.62c-4.1 1.3-7 4.56-7 8.38v4a2.006 2.006 0 00-2 2v3h26v-3a2.006 2.006 0 00-2-2z"
                    fill="#e4c05c"
                />
                <path d="M28 24h13v-4H19v4h4z" fill="#b19046" />
                <path
                    d="M41 20H19c0-3.82 2.9-7.08 7-8.38a13.213 13.213 0 018 0c4.1 1.3 7 4.56 7 8.38z"
                    fill="#14a085"
                />
                <path d="M24 20c0-4.971 2.686-9 6-9s6 4.029 6 9z" fill="#26b99a" />
                <path d="M19 39.04V59h-4V39.03l3.7.01z" fill="#e4c05c" />
                <path
                    d="M37 39.07V59h-4v-9a3 3 0 00-6 0v9h-4V39.05h.3l13.34.02z"
                    fill="#603e26"
                />
                <path d="M41 39v.08l-4-.01-14-.02-4-.01V39z" fill="#65ddb9" />
                <path d="M45 39.09V59h-4V39.08h.39z" fill="#e4c05c" />
                <path
                    d="M45 28v11.09l-4-.01V39h.49a.509.509 0 00.27-.94l-11.49-6.99a.574.574 0 00-.54 0l-11.49 6.99a.509.509 0 00.27.94H19v.04l-4-.01V28z"
                    fill="#f5efca"
                />
                <path
                    d="M8.5 51a2.5 2.5 0 012.5 2.5V59H6v-5.5A2.5 2.5 0 018.5 51z"
                    fill="#603e26"
                />
                <path
                    d="M12 53.5V59h-2v-5.5a1.5 1.5 0 00-3 0V59H5v-5.5a3.5 3.5 0 017 0z"
                    fill="#e4c05c"
                />
                <path
                    d="M8.5 42a2.5 2.5 0 012.5 2.5V47H6v-2.5A2.5 2.5 0 018.5 42z"
                    fill="#95a5a5"
                />
                <rect fill="#393f4a" height={5} rx={1} width={5} x={6} y={31} />
                <path
                    d="M51.5 51a2.5 2.5 0 012.5 2.5V59h-5v-5.5a2.5 2.5 0 012.5-2.5z"
                    fill="#603e26"
                />
                <path
                    d="M51.5 42a2.5 2.5 0 012.5 2.5V47h-5v-2.5a2.5 2.5 0 012.5-2.5z"
                    fill="#95a5a5"
                />
                <path
                    d="M11 48H6a1 1 0 01-1-1v-2.5a3.5 3.5 0 017 0V47a1 1 0 01-1 1zm-4-2h3v-1.5a1.5 1.5 0 00-3 0zM54 48h-5a1 1 0 01-1-1v-2.5a3.5 3.5 0 017 0V47a1 1 0 01-1 1zm-4-2h3v-1.5a1.5 1.5 0 00-3 0z"
                    fill="#e4c05c"
                />
                <rect fill="#393f4a" height={5} rx={1} width={5} x={49} y={31} />
                <path
                    d="M10 37H7a2 2 0 01-2-2v-3a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2zm-3-5v3h3v-3zM53 37h-3a2 2 0 01-2-2v-3a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2zm-3-5v3h3v-3z"
                    fill="#e4c05c"
                />
                <path d="M23 39v.05l-4-.01V39zM41 39v.08l-4-.01V39z" fill="#65ddb9" />
                <path
                    d="M41.49 39H18.51a.509.509 0 01-.27-.94l11.49-6.99a.574.574 0 01.54 0l11.49 6.99a.509.509 0 01-.27.94z"
                    fill="#e4c05c"
                />
                <path d="M33 50v9h-6v-9a3 3 0 016 0z" fill="#c03a2b" />
                <path d="M31 37h-2a1 1 0 010-2h2a1 1 0 010 2z" fill="#b19046" />
                <path
                    d="M59 40h-1l-57-.113A.945.945 0 111 38h1l57 .113A.945.945 0 1159 40z"
                    fill="#805333"
                />
                <path
                    d="M55 53.5V59h-2v-5.5a1.5 1.5 0 00-3 0V59h-2v-5.5a3.5 3.5 0 017 0z"
                    fill="#e4c05c"
                />
                <g fill="#b19046">
                    <path d="M20 59h-2l-.04-19a.987.987 0 01.74-.96.746.746 0 01.26-.04 1 1 0 011 1zM24.04 59h-2L22 40a1 1 0 011-1c.549.008.992.451 1 1zM38.04 59h-2L36 40a1 1 0 01.64-.93A.857.857 0 0137 39a1 1 0 011 1zM42.04 59h-2L40 40a1 1 0 012 0z" />
                    <path d="M41.49 40H18.51a1.51 1.51 0 01-.8-2.787l11.5-7a1.6 1.6 0 011.526-.029l11.542 7.02A1.509 1.509 0 0141.49 40zm-21.227-2h19.474L30 32.075z" />
                </g>
            </g>
        </svg>
    );
}

export default CatholicChurch;